module.exports = __webpack_public_path__ + "img/ttshop_tk.406f44f1.svg";